var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconReplay01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.65 2.228A8.45 8.45 0 0 1 8 .325v.8-.8A7.675 7.675 0 1 1 .325 8v-.8h1.6V8A6.075 6.075 0 1 0 8 1.925h-.001A6.85 6.85 0 0 0 3.66 3.467l-.62.506-1.011-1.24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.658.154 4.21.542l-.529 2.116 2.116.529-.388 1.552-3.668-.917z"
}))));
export default SvgIconReplay01;